var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarte(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 120,
    viewBox: "0 0 212 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1517_8384)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.514 0H20.4504C11.8979 0 4.96484 6.35114 4.96484 14.1857V105.814C4.96484 113.649 11.8979 120 20.4504 120H196.514C205.066 120 211.999 113.649 211.999 105.814V14.1857C211.999 6.35114 205.066 0 196.514 0Z",
    fill: "#0E99A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.999 27.6406H4.96484V45.9895H211.999V27.6406Z",
    fill: "#191F33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.549 0H15.4855C6.9331 0 0 6.35114 0 14.1857V105.814C0 113.649 6.9331 120 15.4855 120H191.549C200.101 120 207.035 113.649 207.035 105.814V14.1857C207.035 6.35114 200.101 0 191.549 0Z",
    fill: "#30D6E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207.035 27.6406H0V45.9895H207.035V27.6406Z",
    fill: "#282E47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2777 63.1406H11.4023V69.8865H79.2777V63.1406Z",
    fill: "#99FDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1808 79.293H11.4023V86.0389H65.1808V79.293Z",
    fill: "#99FDFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.487 79.293H70.6914V86.0389H113.487V79.293Z",
    fill: "#99FDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.532 95.4805H41.9961V102.226H113.532V95.4805Z",
    fill: "#99FDFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6505 95.4805H11.4023V102.226H36.6505V95.4805Z",
    fill: "#99FDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.764 82.6854C166.764 91.2045 159.231 98.066 149.974 98.066C140.716 98.066 133.184 91.1659 133.184 82.6854C133.184 74.2048 140.716 67.3047 149.974 67.3047C159.231 67.3047 166.764 74.2048 166.764 82.6854Z",
    fill: "#FF971A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M194.537 82.6854C194.537 91.2045 187.005 98.066 177.747 98.066C168.489 98.066 160.957 91.1659 160.957 82.6854C160.957 74.2048 168.489 67.3047 177.747 67.3047C187.005 67.3047 194.537 74.2048 194.537 82.6854Z",
    fill: "#FFE83E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M204.51 6.51462C201.817 2.58272 197.188 0 191.97 0H15.0647C6.73283 0 0 6.55316 0 14.6097V105.39C0 108.821 1.26241 111.905 3.28225 114.372L204.51 6.51462Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1517_8384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 120,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarte);
export default __webpack_public_path__ + "static/media/carte.474f315acc5c2edee3b636ccdfe1579b.svg";
export { ForwardRef as ReactComponent };